"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCompleteUploadBodySchema = exports.MediaRequestUploadBodySchema = void 0;
const v4_1 = require("zod/v4");
exports.MediaRequestUploadBodySchema = v4_1.z.array(v4_1.z.object({
    filename: v4_1.z.string(),
    size: v4_1.z.number(),
    folderId: v4_1.z.number().nullable().optional(),
}));
exports.MediaCompleteUploadBodySchema = v4_1.z.object({
    mediaID: v4_1.z.number(),
});
